export default {
  title: 'light',
  colors: {
    primary: '#0771B1',
    secondary: '#67C7F1',
    tertiary: '#ECF3FB',

    background: '#F7F8FE',
    backgroundSecondary: '#EAEBEE',
    backgroundTertiary: '#D9DADD',

    placeholder: '#666360',
    text: '#333',
    textSecondary: '#F5F5F5',

    golden: '#B67102', /*'#F29602',*/

    mainColor: '#0071A9',
    secondaryColor: '#67C7F1',

    error: '#C53030',
    errorText: '#fddede',

    success: '#28A745',
    sucessText: '#CAFFD5',
  },
}
